module.exports = __webpack_public_path__ + "img/info-circle.607344da.svg";